import { useSearchParam as useSearchParamReactUse } from 'react-use';

export const useSearchParam = (key: string, defaultValue = '') => {
  const params = useSearchParamReactUse(key);
  return params || defaultValue;
};
